module.exports = __webpack_public_path__ + "img/poele.bebaa52.svg";